import { Asterisk } from "lucide-react";

const items = ["Life Insurance", "Health Insurance", "Motor Insurance", "Home Insurance", "Business Insurance", "Travel Insurance"];

const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
        {items.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-4xl font-light italic text-moss md:text-6xl">{item}</span>
                <Asterisk size={28} className="shrink-0 text-clay" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <section data-testid="coverage-marquee" className="overflow-hidden border-y border-line py-10 md:py-14">
        <div className="animate-marquee flex w-max">
            <Row hidden={false} />
            <Row hidden={true} />
        </div>
    </section>
);
